/**
 * Non-persisted token ids from the API use prefix "cg:" (CoinGecko-only view).
 * The backend addTransaction mutation automatically imports ephemeral tokens.
 */
export function isEphemeralTokenId(id) {
  return typeof id === 'string' && id.startsWith('cg:');
}
